export interface KpiCardProps {
  /** Rótulo do indicador. */
  readonly label: string;
  /** Valor principal já formatado (ex.: `"R$ 1.284,30"`). */
  readonly value: string;
  /** Texto auxiliar sob o valor (ex.: unidade ou período). */
  readonly hint?: string;
  /** Destaca o card como indicador principal do conjunto. */
  readonly emphasis?: boolean;
}

/**
 * Card de indicador do dashboard: rótulo, valor em destaque e texto auxiliar.
 *
 * O valor usa `tabular-nums` para que os dígitos fiquem alinhados entre os cards da
 * mesma linha, evitando a dança de largura quando os números mudam com o filtro.
 */
export function KpiCard({ label, value, hint, emphasis = false }: KpiCardProps) {
  return (
    <div className="flex flex-col gap-quark rounded-md border-hairline border-ctx-layout-border bg-ctx-layout-surface p-xxs shadow-level1">
      <span className="uppercase tracking-wide text-ctx-content-placeholder ts-caption-xxs">
        {label}
      </span>
      <span
        className={`tabular-nums ${emphasis ? 'text-ctx-content-title ts-heading-md' : 'text-ctx-content-title ts-heading-sm'}`}
      >
        {value}
      </span>
      {hint ? <span className="text-ctx-content-placeholder ts-caption-xxs">{hint}</span> : null}
    </div>
  );
}
